import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-graph-trend-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './graph-trend-icon.component.html',
  styleUrl: './graph-trend-icon.component.scss'
})
export class GraphTrendIconComponent {

  @Input() isUptrendPositive: boolean = true;
  @Input() percentageChange: number = 0;
  @Input() formattedChange: string = '';
  @Input() formatValue: string = '';

  fillColor: string = '#50AD41';
  constructor() { }

  getFillColor(): string {
    if (this.percentageChange > 0) {
      return this.isUptrendPositive ? '#50AD41' : '#FF7F00';
    }
    if (this.percentageChange < 0) {
      return this.isUptrendPositive ? '#FF7F00' : '#50AD41';
    }
    if (this.percentageChange == null || this.percentageChange == undefined) {
      return '#4d4749'
    }
    if (this.percentageChange === 0) {
      return '#4d4749';
    }

    return '#FF7F00';
  }
}